/**
 * Largest-remainder rounding so two displayed percentages always sum to 100.
 */
export function roundPercentages(votes1, votes2) {
    const total = votes1 + votes2;
    if (total === 0) {
        return [50, 50];
    }
    const exact1 = (votes1 / total) * 100;
    const exact2 = (votes2 / total) * 100;
    const floor1 = Math.floor(exact1);
    const floor2 = Math.floor(exact2);
    const remainder1 = exact1 - floor1;
    const remainder2 = exact2 - floor2;
    let result1 = floor1;
    let result2 = floor2;
    const diff = 100 - (floor1 + floor2);
    if (diff === 1) {
        if (remainder1 >= remainder2) {
            result1++;
        }
        else {
            result2++;
        }
    }
    else if (diff === 2) {
        result1++;
        result2++;
    }
    return [result1, result2];
}
